"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AlertWindow = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "alert__AlertWindow",
  componentId: "sc-g632j6-0"
})(["border-radius:26px;box-shadow:0 2px 3px 1px ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.8, "shadow", props);
});
var CloseGlyph = (0, _styledComponents["default"])(_components.FormGlyph).withConfig({
  displayName: "alert__CloseGlyph",
  componentId: "sc-g632j6-1"
})(["cursor:pointer;"]);
var propTypes = {
  /** A popup component */
  children: _propTypes.node,

  /** closeClick event handler - used to process close glyph click */
  closeClick: _propTypes.func,

  /** A flag to check if the alert is open or not */
  isOpen: _propTypes.bool,

  /** A string representing the HTML5 input type */
  type: (0, _propTypes.oneOf)(["success", "notification", "warning", "error"])
};
var defaultProps = {
  isOpen: false
};

var AlertComponent = function AlertComponent(_ref) {
  var closeClick = _ref.closeClick,
      children = _ref.children,
      type = _ref.type;
  var glyphs = {
    error: "error",
    notification: "info",
    success: "check-circle",
    warning: "warning"
  };
  var backgrounds = {
    error: "error",
    notification: "notification",
    success: "success",
    warning: "warning"
  };
  return /*#__PURE__*/_react["default"].createElement(AlertWindow, {
    alignItems: "center",
    backgroundColor: backgrounds[type],
    flexDirection: "row",
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(_components.FormGlyph, {
    fill: "background",
    id: glyphs[type],
    ml: 1
  }), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: "background"
  }, _utils.defaultFontSize, _utils.defaultSpacing, {
    width: 1
  }), children), /*#__PURE__*/_react["default"].createElement(CloseGlyph, {
    fill: "background",
    id: "close",
    mx: 1,
    onClick: closeClick
  }));
};

AlertComponent.propTypes = propTypes;
AlertComponent.defaultProps = defaultProps;
AlertComponent.displayName = "Modules.AlertComponent";
var _default = AlertComponent;
exports["default"] = _default;